import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "flex gap-2 h-full p-2 overflow-hidden" }
const _hoisted_2 = { class: "flex flex-col w-[250px] rounded overflow-hidden flex-shrink-0 gap-2" }
const _hoisted_3 = { class: "h-1/2 flex flex-col bg-trader-gray rounded overflow-hidden shrink-0" }
const _hoisted_4 = { class: "flex-grow p-2 flex flex-col gap-2 overflow-auto" }
const _hoisted_5 = { class: "flex flex-col h-1/2 bg-trader-gray rounded overflow-hidden shrink-0" }
const _hoisted_6 = { class: "flex-grow p-2 flex flex-col gap-2 overflow-auto" }
const _hoisted_7 = { class: "flex flex-grow rounded bg-trader-gray overflow-x-hidden overflow-y-auto" }
const _hoisted_8 = {
  key: 0,
  class: "flex flex-col p-4 w-full"
}

import {eventBus} from "@/application/EventBus";
import NewsletterImport from "@/components/Dialogs/NewsletterImport.vue";
import {computed, onMounted, ref} from "vue";
import {useRoute} from "vue-router";
import ImportExcel from "@/components/Dialogs/ImportExcel.vue";
import ExportExcel from "@/components/Dialogs/ExportExcel.vue";
import ExcelExportInfo from "@/components/Dialogs/ExcelExportInfo.vue";
import PrimaryProductExport from "@/components/Dialogs/PrimaryProductExport.vue";
import {mapState, useStore} from "vuex";
import JSONExport from "@/components/Dialogs/JSONExport.vue";
import CustomerExport from "@/components/Dialogs/CustomerExport.vue";

export default /*@__PURE__*/_defineComponent({
  __name: 'ChoseExcelImport',
  setup(__props) {



const store = useStore();
const userData = computed(() => store.state.user.userData);
const projectId = ref<number>(0);
const magazineId = ref<number>(0);
const activeView = ref<string>("");

const route = useRoute(); // <-- Hier definierst du die Konstante 'route'

function showView(type: string) {
  activeView.value = type;
}

function goToNewsLetterImport() {
  eventBus.openModal(NewsletterImport, {
    title: "Newsletter Import",
    projectId: projectId.value,
    magazineId: magazineId.value
  });
}

function goToRegionalImport() {
  eventBus.openModal(ImportExcel, {
    title: "Regional Import",
    magazineId: magazineId.value
  });
}

onMounted(async () => {
  if (route.params.projectId) {
    projectId.value = parseInt(route.params.projectId as string, 10);
  }

  if (route.params.magazineId) {
    magazineId.value = parseInt(route.params.magazineId as string, 10);
  }
});



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _cache[7] || (_cache[7] = _createElementVNode("h1", { class: "text-lg text-white text-center bg-trader-darkest-gray dark:bg-trader-darker-gray py-1" }, "Importieren", -1)),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", {
            class: _normalizeClass(["w-full p-1 flex cursor-pointer", { 'bg-trader-blue text-white': activeView.value == 'standard-import', 'bg-trader-dark-gray': activeView.value != 'standard-import' }]),
            onClick: _cache[0] || (_cache[0] = ($event: any) => (showView('standard-import')))
          }, " Standard Import ", 2),
          _createElementVNode("div", {
            class: _normalizeClass(["w-full p-1 flex cursor-pointer", { 'bg-trader-blue text-white': activeView.value == 'newsletter-import', 'bg-trader-dark-gray': activeView.value != 'newsletter-import' }]),
            onClick: _cache[1] || (_cache[1] = ($event: any) => (showView('newsletter-import')))
          }, " Newsletter Import ", 2)
        ])
      ]),
      _createElementVNode("div", _hoisted_5, [
        _cache[8] || (_cache[8] = _createElementVNode("h1", { class: "text-lg text-center text-white bg-trader-darkest-gray dark:bg-trader-darker-gray py-1" }, "Exportieren", -1)),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", {
            class: _normalizeClass(["w-full p-1 flex cursor-pointer", { 'bg-trader-blue text-white': activeView.value == 'standard-export', 'bg-trader-dark-gray': activeView.value != 'standard-export' }]),
            onClick: _cache[2] || (_cache[2] = ($event: any) => (showView('standard-export')))
          }, " Standard Export ", 2),
          _createElementVNode("div", {
            class: _normalizeClass(["w-full p-1 flex cursor-pointer", { 'bg-trader-blue text-white': activeView.value == 'standard-export-info', 'bg-trader-dark-gray': activeView.value != 'standard-export-info'  }]),
            onClick: _cache[3] || (_cache[3] = ($event: any) => (showView('export-info')))
          }, " Export Regional Info ", 2),
          _createElementVNode("div", {
            class: _normalizeClass(["w-full p-1 flex cursor-pointer", { 'bg-trader-blue text-white': activeView.value == 'primary-product-export', 'bg-trader-dark-gray': activeView.value != 'standard-export-info'  }]),
            onClick: _cache[4] || (_cache[4] = ($event: any) => (showView('product')))
          }, " Abbildungsartikel Export ", 2),
          (userData.value?.isSuperAdmin)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: _normalizeClass(["w-full p-1 flex cursor-pointer", { 'bg-trader-blue text-white': activeView.value == 'JSON', 'bg-trader-dark-gray': activeView.value != 'primary-product-export'  }]),
                onClick: _cache[5] || (_cache[5] = ($event: any) => (showView('JSON')))
              }, " JSON Export ", 2))
            : _createCommentVNode("", true),
          _createElementVNode("div", {
            class: _normalizeClass(["w-full p-1 flex cursor-pointer", { 'bg-trader-blue text-white': activeView.value == 'JSON', 'bg-trader-dark-gray': activeView.value != 'primary-product-export'  }]),
            onClick: _cache[6] || (_cache[6] = ($event: any) => (showView('Mailing')))
          }, " Mailing (Top 5 Kunden Produkte) ", 2)
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_7, [
      (activeView.value == '')
        ? (_openBlock(), _createElementBlock("div", _hoisted_8, _cache[9] || (_cache[9] = [
            _createElementVNode("h2", { class: "text-2xl font-bold" }, "Willkommen beim Trader Import & Export", -1),
            _createElementVNode("p", { class: "text-md" }, "Hier können Sie Daten einfach und effizient importieren oder exportieren. ", -1),
            _createElementVNode("p", { class: "text-md" }, "Nutzen Sie das Menü auf der linken Seite, um eine Import- oder Exportvariante auszuwählen.", -1),
            _createElementVNode("p", { class: "text-md" }, "Nach Ihrer Auswahl führt Sie ein intuitiver Wizard durch die nächsten Schritte.", -1)
          ])))
        : _createCommentVNode("", true),
      (activeView.value == 'standard-import')
        ? (_openBlock(), _createBlock(ImportExcel, {
            key: 1,
            class: "overflow-x-hidden overflow-y-auto"
          }))
        : _createCommentVNode("", true),
      (activeView.value == 'standard-export')
        ? (_openBlock(), _createBlock(ExportExcel, {
            key: 2,
            class: "overflow-x-hidden overflow-y-auto"
          }))
        : _createCommentVNode("", true),
      (activeView.value == 'newsletter-import')
        ? (_openBlock(), _createBlock(NewsletterImport, {
            key: 3,
            "project-id": projectId.value,
            "magazine-id": magazineId.value,
            class: "overflow-x-hidden overflow-y-auto"
          }, null, 8, ["project-id", "magazine-id"]))
        : _createCommentVNode("", true),
      (activeView.value == 'export-info')
        ? (_openBlock(), _createBlock(ExcelExportInfo, {
            key: 4,
            "project-id": projectId.value,
            "magazine-id": magazineId.value,
            class: "overflow-x-hidden overflow-y-auto"
          }, null, 8, ["project-id", "magazine-id"]))
        : _createCommentVNode("", true),
      (activeView.value == 'product')
        ? (_openBlock(), _createBlock(PrimaryProductExport, {
            key: 5,
            class: "overflow-x-hidden overflow-y-auto"
          }))
        : _createCommentVNode("", true),
      (activeView.value == 'JSON' && userData.value?.isSuperAdmin)
        ? (_openBlock(), _createBlock(JSONExport, {
            key: 6,
            class: "overflow-x-hidden overflow-y-auto"
          }))
        : _createCommentVNode("", true),
      (activeView.value == 'Mailing' )
        ? (_openBlock(), _createBlock(CustomerExport, { key: 7 }))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})